import * as actionTypes from "../actions/actionTypes";
import {EventInterface} from "../declarations";
import {updateObject} from "../../utils/functions/common";

const initialState: EventInterface = {
    id: -1,
    name: '',
    address: '',
    city: '',
    logo: '',
    sports: '',
    hospitals: [],
    accreditation: [],
    emails: '',
    start: '',
    end: ''
};

const setEvent = (state: any, action: any) => {
    return updateObject(state, action.event);
};

const clearEvent = (state: any, action: any) => {
    return updateObject(state, initialState);
};

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.SET_EVENT:
            return setEvent(state, action);
        case actionTypes.CLEAR_EVENT:
            return clearEvent(state, action);
        default:
            return state;
    }
};

export default reducer;
